'use strict';
angular.module('webAgro1App').factory('DemandaUsoInsumosService', function($http) {
  return {
    get: function(params) {
      const url = `${SERVER + API_VERSION }demanda_uso_insumos`;

      return $http.get(url, { params: params });
    }
  };
});
